import React from "react";
import "./QrGen.css";
var QRCode = require("qrcode.react");

function QrGen() {
  return (
    <div>
      <img src="./images/bundleback.png" className="wallpaper" />
      <div className="Qr-Content">
        <img src="./images/Elippman.jpeg" className="circular--portrait" />
        <h1 className="Qr-name">@ELippman</h1>
        <QRCode
          className="ActQr"
          value="https://thaveesi.github.io/lippman2/"
        />
        <p className="dialogue"> &nbsp; Scan to add Ethan's Bundle </p>
      </div>
    </div>
  );
}

export default QrGen;
